export enum SearchEndpointsEnum {
  // SEARCH = "/search",
  // SEARCH_FILTERS = "/search/filters",
  FILTERS = "/search",
  SEARCH = "/v2/products",
  SEARCH_FILTERS = "/products/filters",
}
